module.exports = __webpack_public_path__ + "static/media/lunchType-sandwich.c5169aa6.jpg";